import { saveAs } from 'file-saver'
import { BACKEND_URL } from './settings'

export const downloadImage = (): void => {
  saveAs(
    `${BACKEND_URL}/images/logos/pendixinfo.png`,
    'Velorbis eDrive battery distances.png'
  )
}
